import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Modal } from 'reactstrap';
import Close from './Close';
import WorkerItemForSelection from './WorkerItemForSelection';
import Validator from '../../common/forms/Validator';
import ErrorMessage from '../../common/forms/ErrorMessage';

export default class AddWorkerModal extends Validator {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    workersPredictionsList: PropTypes.array.isRequired,
    searchData: PropTypes.shape({
      job_skill_id: PropTypes.number,
      ranking_number: PropTypes.number,
      job_id: PropTypes.number,
      job_date: PropTypes.string
    }),
    workersMaxQuantity: PropTypes.number,
    closeModal: PropTypes.func.isRequired,
    addWorkersSubmit: PropTypes.func.isRequired,
    searchAction: PropTypes.func.isRequired,
    setWorkersPredictions: PropTypes.func,
    loadDefaultPredictionsList: PropTypes.func,
    clearWorkersPredictionsList: PropTypes.func.isRequired
  };

  static defaultProps = {
    messages: {
      maxLength: 'Only {1} worker(s) can be added.'
    }
  };

  constructor (props) {
    super(props);
    this.state = {
      searchValue: '',
      selectedWorkers: []
    };
    this.validationRules = {};
    const { workersMaxQuantity } = props;
    if (workersMaxQuantity) {
      this.validationRules.selectedWorkers = { maxLength: workersMaxQuantity };
    }
  }

  componentDidMount () {
    const { loadDefaultPredictionsList } = this.props;
    if (loadDefaultPredictionsList) {
      loadDefaultPredictionsList();
    }
  }

  handleInputText = e => {
    const { value } = e.target;
    this.setState({ searchValue: value });
    if (value) {
      const { searchData } = this.props;
      if (searchData) {
        return this._searchAction(value, searchData);
      } else {
        return this._searchAction(value);
      }
    }
    const { setWorkersPredictions, clearWorkersPredictionsList } = this.props;
    if (setWorkersPredictions) {
      setWorkersPredictions();
    } else {
      clearWorkersPredictionsList();
    }
  };

  _searchAction = _.debounce(this.props.searchAction, 500);

  handleWorkerSelection = selectedWorker => {
    let { selectedWorkers } = this.state;
    const selectedWorkerIndex = selectedWorkers.findIndex(worker => (worker.id === selectedWorker.id));
    if (selectedWorkerIndex < 0) {
      selectedWorkers.push(selectedWorker);
    } else {
      selectedWorkers.splice(selectedWorkerIndex, 1);
    }
    this.setState({ selectedWorkers });
  };

  _mapWorkersById () {
    return this.state.selectedWorkers.map(worker => worker.id);
  };

  submitSelect = () => {
    this._resetErrors();
    if (!this.validate(this.validationRules)) {
      return;
    }
    const { addWorkersSubmit } = this.props;
    const { selectedWorkers } = this.state;
    this.closeModal();
    if (selectedWorkers.length > 0) {
      addWorkersSubmit(selectedWorkers);
    }
  };

  closeModal = () => {
    this.props.closeModal();
    this.props.clearWorkersPredictionsList();
    this.setState({ searchValue: '', selectedWorkers: [] });
  };

  render () {
    const { searchValue } = this.state;
    const { isOpen, workersPredictionsList } = this.props;
    const selectedWorkersIds = this._mapWorkersById();
    const errors = this.validationErrors;
    return (
      <Modal isOpen={isOpen} centered>
        <div className='modal-header'>
          <div className='modal-title'>Add Worker</div>
          <Close onClick={this.closeModal} />
        </div>
        <div className='modal-body'>
          <input
            className='input mb-3'
            type='text'
            placeholder='Start typing user name or email'
            value={searchValue}
            onChange={this.handleInputText}
          />
          { workersPredictionsList && workersPredictionsList.length > 0 && (
            <div className='mb-3'>
              <div className='user-predictions-modal-list'>
                { workersPredictionsList.map(worker => (
                  <WorkerItemForSelection
                    key={worker.id}
                    worker={worker}
                    isSelected={selectedWorkersIds.includes(worker.id)}
                    handleWorkerSelection={this.handleWorkerSelection}
                  />
                ))}
              </div>
            </div>
          )}
          <ErrorMessage errorText={errors.selectedWorkers} className='mb-2 text-right' />
          <button
            className='button button-primary w-100'
            onClick={this.submitSelect}
          >
            Add
          </button>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/ui/AddWorkerModal.js